import { EventEmitter } from '@angular/core';
import { GenericListButtonClickHandlerData } from './generic-list-button-click-handler-data';

export class GenericListButtonDefinition {
  buttonColor: string;
  buttonTitle: string;
  data: any;
  clickHandler: EventEmitter<GenericListButtonClickHandlerData>;
  disabled = false;

  constructor(
    data: any,
    clickHandler: EventEmitter<GenericListButtonClickHandlerData>,
    buttonTitle: string,
    buttonColor = 'primary',
    disabled?: boolean
  ) {
    this.buttonColor = buttonColor;
    this.buttonTitle = buttonTitle;
    this.data = data;
    this.clickHandler = clickHandler;
    this.disabled = disabled;
  }
}
